// This file is autogenerated from /frontend/sail-next/packages/docs/src/component-examples/Notice/Basic.story.tsx with go/sail-next-tailor-docs-publisher 

import React from 'react';
import { Notice, view, Button } from '@sail/ui';
export const Basic = () => 
<view.div css={{
  layout: 'column',
  gap: 'medium'
}}>
  <Notice
    type="neutral"
    onDismiss={() => console.log('hello world')}
    title="Neutral title"
    description="A short description"
    actions={
      <Button onPress={() => console.log('hello world')}>
        Button
      </Button>}    
  />

  <Notice 
    type="attention"
    title="Attention notice"
    description="Automatically sets the icon to a warning circle and the color to yellow"
    onDismiss={() => console.log('hello world')}
  />

  <Notice
    type="negative"
    title="Negative notice"
    description="Automatically sets the icon to a warning triangle and the color to red."  
  />

  <Notice 
    type="positive"
    title="Positive notice"
    description="Automatically sets the icon to a checkmark and the color to green."
    onDismiss={() => console.log('hello world')}
    actions={<Button onPress={() => console.log('hello world')}>Accept</Button>} 
  />
</view.div>;
